import App, {Tool} from '../App';
import Api from './Api';
import Resource from '../Resource';

class OrgEmerRequest {
    static data(props) {
        App.log('ORG_EMER_REQUEST.DATA', App.LOG.FETCH, props);

        const body = {
            sectionRequestId: props.sectionRequestId
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.DATA, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve({...result.objList[0]?.hospitalEmgRequestFormVM, ...result.objList[0]?.requestInfo});
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static delete(props) {
        App.log('ORG_EMER_REQUEST.DELETE', App.LOG.FETCH, props);

        const body = {
            sectionRequestId: props.sectionRequestId,
            statusId: 21
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.UPDATE_STATE, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.DELETE_FAILED);
            });
        });
    }
}

class SectionOrgEmerRequest extends OrgEmerRequest {
    static insert(props) {
        App.log('SECTION_ORG_EMER_REQUEST.INSERT', App.LOG.FETCH, props);

        const body = {
            patientFileCodeId: props?.patientFileCodeId,
            patientFileCode: props?.patientFileCode,
            patientFirstName: props?.patientFirstName,
            patientLastName: props?.patientLastName,
            sectionId: props?.sectionId,
            docterId: props?.docterId,
            patientBiography: props?.patientBiography
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.SECTION.ORG_EMER.INSERT, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.INSERT_FAILED);
            });
        });
    }

    static list() {
        App.log('SECTION_ORG_EMER_REQUEST.LIST', App.LOG.FETCH);

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.SECTION.ORG_EMER.LIST, {
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static update(props) {
        App.log('SECTION_ORG_EMER_REQUEST.UPDATE', App.LOG.FETCH, props);

        const body = {
            hospitalEmgRequestId: props?.hospitalEmgRequestId,
            patientFileCodeId: props?.patientFileCodeId,
            patientFileCode: props?.patientFileCode,
            patientFirstName: props?.patientFirstName,
            patientLastName: props?.patientLastName,
            sectionId: props?.sectionId,
            docterId: props?.docterId,
            patientBiography: props?.patientBiography
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.SECTION.ORG_EMER.UPDATE, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.UPDATE_FAILED);
            });
        });
    }
}

class HospitalOrgEmerRequest extends OrgEmerRequest {
    static list() {
        App.log('HOSPITAL_ORG_EMER_REQUEST.LIST', App.LOG.FETCH);

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.HOSPITAL.ORG_EMER.LIST, {
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static sendToOrg(props) {
        App.log('HOSPITAL_ORG_EMER_REQUEST.SEND_TO_ORG', App.LOG.FETCH, props);

        const body = {
            hospitalRequestId: props?.hospitalRequestId
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.HOSPITAL.SEND_TO_ORG, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.UPDATE_FAILED);
            });
        });
    }

    static update(props) {
        App.log('HOSPITAL_ORG_EMER_REQUEST.UPDATE', App.LOG.FETCH, props);

        const body = {
            hospitalEmgRequestId: props?.hospitalEmgRequestId,
            wbJson: {
                o_POSCount: props?.wbJson?.o_POSCount,
                o_NEGCount: props?.wbJson?.o_NEGCount,
                a_POSCount: props?.wbJson?.a_POSCount,
                a_NEGCount: props?.wbJson?.a_NEGCount,
                b_POSCount: props?.wbJson?.b_POSCount,
                b_NEGCount: props?.wbJson?.b_NEGCount,
                aB_POSCount: props?.wbJson?.aB_POSCount,
                aB_NEGCount: props?.wbJson?.aB_NEGCount,
                sum: props?.wbJson?.sum,
                description: props?.wbJson?.description
            },
            rbcJson: {
                o_POSCount: props?.rbcJson?.o_POSCount,
                o_NEGCount: props?.rbcJson?.o_NEGCount,
                a_POSCount: props?.rbcJson?.a_POSCount,
                a_NEGCount: props?.rbcJson?.a_NEGCount,
                b_POSCount: props?.rbcJson?.b_POSCount,
                b_NEGCount: props?.rbcJson?.b_NEGCount,
                aB_POSCount: props?.rbcJson?.aB_POSCount,
                aB_NEGCount: props?.rbcJson?.aB_NEGCount,
                sum: props?.rbcJson?.sum,
                description: props?.rbcJson?.description
            },
            pltJson: {
                o_POSCount: props?.pltJson?.o_POSCount,
                o_NEGCount: props?.pltJson?.o_NEGCount,
                a_POSCount: props?.pltJson?.a_POSCount,
                a_NEGCount: props?.pltJson?.a_NEGCount,
                b_POSCount: props?.pltJson?.b_POSCount,
                b_NEGCount: props?.pltJson?.b_NEGCount,
                aB_POSCount: props?.pltJson?.aB_POSCount,
                aB_NEGCount: props?.pltJson?.aB_NEGCount,
                sum: props?.pltJson?.sum,
                description: props?.pltJson?.description,
            },
            ffpJson: {
                o_POSCount: props?.ffpJson?.o_POSCount,
                o_NEGCount: props?.ffpJson?.o_NEGCount,
                a_POSCount: props?.ffpJson?.a_POSCount,
                a_NEGCount: props?.ffpJson?.a_NEGCount,
                b_POSCount: props?.ffpJson?.b_POSCount,
                b_NEGCount: props?.ffpJson?.b_NEGCount,
                aB_POSCount: props?.ffpJson?.aB_POSCount,
                aB_NEGCount: props?.ffpJson?.aB_NEGCount,
                sum: props?.ffpJson?.sum,
                description: props?.ffpJson?.description,
            },
            cryJson: {
                o_POSCount: props?.cryJson?.o_POSCount,
                o_NEGCount: props?.cryJson?.o_NEGCount,
                a_POSCount: props?.cryJson?.a_POSCount,
                a_NEGCount: props?.cryJson?.a_NEGCount,
                b_POSCount: props?.cryJson?.b_POSCount,
                b_NEGCount: props?.cryJson?.b_NEGCount,
                aB_POSCount: props?.cryJson?.aB_POSCount,
                aB_NEGCount: props?.cryJson?.aB_NEGCount,
                sum: props?.cryJson?.sum,
                description: props?.cryJson?.description,
            }
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.HOSPITAL.ORG_EMER.UPDATE, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.UPDATE_FAILED);
            });
        });
    }
}

class OrganizationOrgEmerRequest extends OrgEmerRequest {
    static data(props) {
        App.log('ORGANIZATION_ORG_EMER_REQUEST.DATA', App.LOG.FETCH, props);

        const body = {
            hospitalRequestId: props.hospitalRequestId
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.ORG.DATA, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve({...result.objList[0]?.hospitalEmgRequestFormVM, ...result.objList[0]?.requestInfo});
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static list() {
        App.log('ORGANIZATION_ORG_EMER_REQUEST.LIST', App.LOG.FETCH);

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.ORG.EMER.LIST, {
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }
}

export {SectionOrgEmerRequest, HospitalOrgEmerRequest, OrganizationOrgEmerRequest};